import React from 'react';

/**
 * Footer component for the Old World Treasures website.
 * Displays copyright information.
 */
const Footer = () => {
  return (
    <footer className="bg-primary-dark text-header-footer-text p-4 text-center mt-auto rounded-t-lg">
      <div className="container mx-auto text-sm">
        &copy; {new Date().getFullYear()} {process.env.REACT_APP_TITLE}. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
